import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { useRef, useState } from 'react';
import { postAllData } from '../../service/ProductService';
import { HOLDUNHOLDAPPLICATION, SCRUTINY_HOLD } from '../../config/ApiConstant';
import { InputTextarea } from 'primereact/inputtextarea';
import { PermanentFileCloseValidation } from '../../config/Validate';
import { useNavigate } from 'react-router-dom';

const ScrutinyPermanentCloseModal = (props: any) => {
    const toast = useRef<any>(null);
    const navigate = useNavigate();

    const [holdBtnSpinner, setHoldBtnSpinner] = useState<boolean>(false);
    const [reason, setReason] = useState<any>('');
    const [errors, setErrors] = useState<any>({});

    const permanentFileClose = async () => {
        try {
            const { isError, errors } = PermanentFileCloseValidation(reason);
            setErrors(errors);
            if (!isError) {
                setHoldBtnSpinner(true);

                // Request Data
                const requestData = {
                    SrNo: props?.fileNo,
                    RegCNote: reason,
                    RegCancle: 2
                };
                // Api Call
                const response = await postAllData(HOLDUNHOLDAPPLICATION, requestData);

                if (response) {
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });

                    setHoldBtnSpinner(false);
                    setReason('');
                    props.dismissClick();
                    setTimeout(() => {
                        
                        setTimeout(() => {
                            props.appName === 'Fresh Registration Other State' ? navigate(`/app/scrutiny/other-state-scrutiny/${props?.activeIndex}`) : props.appName === 'Transfer In' ? navigate(`/app/scrutiny/transfer-to-gujarat-scrutiny/${props?.activeIndex}`) : props.appName === 'Transfer DD/DNH' ? navigate(`/app/scrutiny/transfer-to-dd-dnh-scrutiny/${props?.activeIndex}`) : navigate(`/app/scrutiny/fresh-registration-scrutiny/${props?.activeIndex}`);
                        }, 1500);
                    }, 1500);
                }
            }
        } catch (error: any) {
            if (error.response) {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });

                setHoldBtnSpinner(false);

                props.dismissClick();
            }
        }
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={props.openmodel}
                className="p-fluid"
                style={{ width: '600px' }}
                header="Permanent File Close"
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" className="p-button-secondary" onClick={() => props.dismissClick()} />
                        <Button label="Permanent Close" className="p-button-danger" onClick={() => permanentFileClose()} loading={holdBtnSpinner} />
                    </>
                }
                onHide={() => props.dismissClick()}
            >
                <div className="field ">
                    <label htmlFor="reason">
                        Reason <span style={{ color: 'red' }}>*</span>
                    </label>
                    <InputTextarea value={reason} name="reason" className={errors['reason'] && 'p-invalid'} onChange={(e) => setReason(e.target.value)} rows={4}></InputTextarea>
                    <small className="p-invalid-txt">{errors['reason']}</small>
                </div>
            </Dialog>
        </>
    );
};
export default ScrutinyPermanentCloseModal;
